import mathImg from "../containers/LandingPage/SectionHero/math.png"
import englishImg from "../containers/LandingPage/SectionHero/english.png"
import scienceImg from "../containers/LandingPage/SectionHero/science.png"
import historyImg from "../containers/LandingPage/SectionHero/history.png"
import languagesImg from "../containers/LandingPage/SectionHero/languages.png"
import artsImg from "../containers/LandingPage/SectionHero/arts.png"

export const heroStylesData = [
  {id: 'math', backgroundColor: '#e35e7a', buttonColor: '#EDCD90', imgSrc: mathImg},
  {id: 'english', backgroundColor: '#b0e0f4', buttonColor: '#3FAFDD', imgSrc: englishImg},
  {id: 'science', backgroundColor: '#4dacec', buttonColor: '#B0E0F5', imgSrc: scienceImg},
  {id: 'history', backgroundColor: '#f1cb82', buttonColor: '#B0E0F5', imgSrc: historyImg},
  {id: 'languages', backgroundColor: '#e793be', buttonColor: '#E85299', imgSrc: languagesImg},
  {id: 'art', backgroundColor: '#c2c2c2', buttonColor: '#4A4A4A', imgSrc: artsImg},
]
